import { jsx as _jsx } from "react/jsx-runtime";
import { faHourglassEnd } from '@fortawesome/pro-duotone-svg-icons/faHourglassEnd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { EmptyState, EmptyStateContainer, EmptyStateIcon } from 'components/atoms/empty-state';
import { Layout } from 'components/organisms/home/overview/layout';
import { ProductiveHeading03 } from 'components/styles';
import { useAccountDataQuery } from 'queries/account';
import { usePlanName } from 'queries/billing';
const Title = styled.div`
  ${ProductiveHeading03};
`;
export const TrialExpired = ({ currentPlan })=>{
    const { data: accountData } = useAccountDataQuery();
    const currentPlanName = usePlanName(currentPlan);
    return /*#__PURE__*/ _jsx(Layout, {
        right: null,
        main: /*#__PURE__*/ _jsx(EmptyStateContainer, {
            children: /*#__PURE__*/ _jsx(EmptyState, {
                image: /*#__PURE__*/ _jsx(EmptyStateIcon, {
                    icon: faHourglassEnd
                }),
                title: /*#__PURE__*/ _jsx(Title, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "billing.trial.expired.modal.title",
                        values: {
                            planName: currentPlanName
                        }
                    })
                }),
                message: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "billing.trial.expired.modal.content",
                    values: {
                        b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                children: chunk
                            }),
                        accountOwnerEmail: accountData === null || accountData === void 0 ? void 0 : accountData.billingMeta.accountAdmin.emailId
                    }
                })
            })
        })
    });
};
export const SubscriptionExpired = ()=>{
    var _ref;
    const { data: accountData } = useAccountDataQuery();
    return /*#__PURE__*/ _jsx(Layout, {
        right: null,
        main: /*#__PURE__*/ _jsx(EmptyStateContainer, {
            children: /*#__PURE__*/ _jsx(EmptyState, {
                image: /*#__PURE__*/ _jsx(EmptyStateIcon, {
                    icon: faHourglassEnd
                }),
                title: /*#__PURE__*/ _jsx(Title, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "billing.subscription.expired.modal.title"
                    })
                }),
                message: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "billing.subscription.expired.modal.content",
                    values: {
                        b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                children: chunk
                            }),
                        accountOwnerEmail: (_ref = accountData === null || accountData === void 0 ? void 0 : accountData.billingMeta.accountAdmin.emailId) !== null && _ref !== void 0 ? _ref : ''
                    }
                })
            })
        })
    });
};
